import React, { useState, useCallback, createContext } from 'react';
import ConfirmModal from './ConfirmModal';
import {useTranslation} from "react-i18next";

export const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const { t } = useTranslation();
  const [confirmData, setConfirmData] = useState({
    open: false,
    title: '',
    message: '',
    onConfirm: null,
    danger: false,
  });

  const openConfirm = useCallback(({ title, message, onConfirm, danger = false }) => {
    setConfirmData({ open: true, title, message, onConfirm, danger });
  }, []);

  const closeConfirm = useCallback(() => {
    setConfirmData(prev => ({ ...prev, open: false }));
  }, []);

  return (
    <ConfirmContext.Provider value={{ openConfirm, closeConfirm }}>
      {children}
      <ConfirmModal
        open={confirmData.open}
        onClose={closeConfirm}
        title={confirmData.title}
        message={confirmData.message}
        confirmText={t('yes')}
        cancelText={t('no')}
        onConfirm={() => {
          confirmData.onConfirm?.();
          closeConfirm();
        }}
        danger={confirmData.danger}
      />
    </ConfirmContext.Provider>
  );
}
